export default [
  {
    title: 'breadcrumb.assistant',
    route: 'list-assistant',
    icon: '',
    resource: 'assistant',
    action: 'read'
  }
];